<template>
	<!-- 检验-报验信息 -->
	<div class="mod-config">
		<el-card body-style="padding-bottom: 0;" style="margin-top: -5px;">
			<div class="title">{{ title }}</div>
			<div class="line"></div>
			<el-row style="margin-top: -10px;margin-left: -20px;width: 100%; line-height:30px;">
				<el-row v-if="showSubject">
					<el-col :span="2">
						<div class="search_title">标的物</div>
					</el-col>
					<el-col :span="22" style="display: flex;flex-wrap: wrap;">
						<span v-for="(subject, index) in subjectList" :key="'sub' + index" style="margin-right: 20px;">
							<span class="search_sec_bn_border"
								v-if="subjectNo === subject.displayValue && subject.displayName == '全部'"
								@click="setSubject(subject)">
								{{ subject.displayName }}
							</span>
							<span class="search_sec_bn"
								v-else-if="subjectNo !== subject.displayValue && subject.displayName == '全部'"
								@click="setSubject(subject)">
								{{ subject.displayName }}
							</span>
							<span class="search_bn_border"
								v-if="subjectNo === subject.displayValue && subject.displayName != '全部'"
								@click="setSubject(subject)">
								{{ subject.displayName }}
							</span>
							<span class="search_bn"
								v-else-if="subjectNo !== subject.displayValue && subject.displayName != '全部'"
								@click="setSubject(subject)">
								{{ subject.displayName }}
							</span>
						</span>
					</el-col>
				</el-row>
				<el-row style="margin-top: 2px;">
					<el-col :span="2">
						<div class="search_title">专业</div>
					</el-col>
					<el-col :span="10" style="display: flex;flex-wrap: wrap;">
						<span v-for="(maj, index) in majorList" :key="'maj' + index" style="margin-right: 20px;">
							<span class="search_sec_bn_border" v-if="major === maj.displayValue" @click="setMajor(maj)">
								{{ maj.displayName }}
							</span>
							<span class="search_sec_bn" v-else-if="major !== maj.displayValue" @click="setMajor(maj)">
								{{ maj.displayName }}
							</span>
						</span>
					</el-col>
					<el-col :span="2">
						<div class="search_title">状态</div>
					</el-col>
					<el-col :span="10" style="display: flex;flex-wrap: wrap;">
						<span v-for="(clo, index) in closeStateList" :key="'clo' + index" style="margin-right: 20px;">
							<span class="search_sec_bn_border" v-if="closeState === clo.value" @click="setClo(clo)">
								{{ clo.label }}
							</span>
							<span class="search_sec_bn" v-else-if="closeState !== clo.value" @click="setClo(clo)">
								{{ clo.label }}
							</span>
						</span>
					</el-col>
				</el-row>
				<el-row style="margin-top: 2px;">
					<el-col :span="2">
						<div class="search_title">检验结论</div>
					</el-col>
					<el-col :span="10" style="display: flex;flex-wrap: wrap;">
						<span v-for="(con, index) in selectConclusionList" :key="'con' + index"
							style="margin-right: 20px;">
							<span class="search_sec_bn_border" v-if="testConclusion === con.displayValue"
								@click="setCon(con)">
								{{ con.displayName }}
							</span>
							<span class="search_sec_bn" v-else-if="testConclusion !== con.displayValue"
								@click="setCon(con)">
								{{ con.displayName }}
							</span>
						</span>
					</el-col>
					<el-col :span="2">
						<div class="search_title">程度</div>
					</el-col>
					<el-col :span="10" style="display: flex;flex-wrap: wrap;">
						<span v-for="(clo, index) in primaryLabelList" :key="'clo' + index" style="margin-right: 20px;">
							<span class="search_sec_bn_border" v-if="primaryFlg === clo.value" @click="setPrimary(clo)">
								{{ clo.label }}
							</span>
							<span class="search_sec_bn" v-else-if="primaryFlg !== clo.value" @click="setPrimary(clo)">
								{{ clo.label }}
							</span>
						</span>
					</el-col>
				</el-row>
			</el-row>
			<div class="line" style="margin-top: 0px;"></div>
			<el-row>
				<el-row
					style="background-color: rgb(243, 247, 247);margin-top: -10px;height: 45px;width: 103%;margin-left: -20px;">
					<el-col :span="11" style="margin-left:15px;margin-top:5px">
						<el-button v-preventReClick class="btn" type="primary" size="small" v-if="showAdd"
							:disabled="updateFlg || addFlg || againFlg" @click="addOrUpdateHandle()">添加</el-button>
						<!-- <el-button v-preventReClick class="btn" type="primary" size="small" v-if="showAdd"
							:disabled="updateFlg || addFlg || againFlg" @click="addHandle()">添加</el-button> -->
						<el-button v-preventReClick class="btn" type="primary" size="small" v-if="showAdd"
							:disabled="updateFlg || addFlg || againFlg" @click="checkHandle()">NO连续性检查</el-button>
						<el-button v-preventReClick class="btn" type="primary" size="small"
							:disabled="updateFlg || addFlg || againFlg" @click="uploadHandle()">导入</el-button>
						<el-button v-preventReClick class="btn" type="primary" size="small"
							:disabled="updateFlg || addFlg || againFlg" @click="downloadHandle()">导出</el-button>
						<el-button v-preventReClick class="btn" type="primary" size="small"
							:disabled="updateFlg || addFlg || againFlg" @click="downloadTemplate()">模板下载</el-button>
						<el-button v-preventReClick :disabled="disabledBatchDelete || updateFlg || addFlg" class="btn"
							type="primary" size="small" @click="deleteBatch()">删除</el-button>
					</el-col>
					<el-col :span="12" style="margin-top: 15px;">
						<div style="float: right;margin-right: 15px;vertical-align:middle;">
							<span style="font-size: 16px; font-weight:bold;vertical-align: middle">
								接受 {{ dataTotal.testConclusionNum }}</span>
							<span
								style="font-size: 16px; font-weight:bold;vertical-align: middle; color: rgb(67, 167, 92);">
								不接受 {{ dataTotal.testConclusionRefuseNum }}</span>
							<span
								style="font-size: 16px; font-weight:bold;vertical-align: middle; color: rgb(240, 159, 8);">
								修正后复检 {{ dataTotal.recheckAfterCorrectionNum }}</span>
							<span
								style="font-size: 16px; font-weight:bold;vertical-align: middle; color: rgb(44, 106, 240);">
								有条件接受 {{ dataTotal.testConclusionWhereNum }}</span>
						</div>
					</el-col>
				</el-row>
				<div class="line" style="margin-top: -4px;"></div>
				<el-form ref="form" :model="form" inline label-width="55px" label-position="left">
					<el-row
						style="background-color: rgb(243, 247, 247);margin-top: -10px;margin-left: -20px;height: 45px;width: 103%;">
						<el-col :span="20" style="margin-left:25px">
							<el-form-item label="检验时间" class="selFormItem2" style="margin-top:2px">
								<el-date-picker class="selDateInput" v-model="testDate" type="daterange"
									range-separator="~" start-placeholder="开始日期" end-placeholder="结束日期" clearable
									value-format="yyyy-MM-dd" :disabled="updateFlg || addFlg || againFlg">
								</el-date-picker>
							</el-form-item>
							<el-form-item label="部件" class="selFormItem2">
								<el-input class="selSearchInput" v-model="partsName"
									:disabled="updateFlg || addFlg || againFlg" clearable></el-input>
							</el-form-item>
							<el-form-item label="检验项目" class="selFormItem2">
								<el-input class="selSearchInput" v-model="probContext"
									:disabled="updateFlg || addFlg || againFlg" clearable></el-input>
							</el-form-item>
							<el-form-item label="检验意见" class="selFormItem2">
								<el-input class="selSearchInput" v-model="sutContent"
									:disabled="updateFlg || addFlg || againFlg" clearable></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="3" class="selBtnGroup">
							<el-button style="margin-top:5px" v-preventReClick class="btn" type="primary" size="small"
								@click="selGetDataList()" :disabled="updateFlg || addFlg || againFlg"
								v-if="showSearch">查询</el-button>
							<el-button v-preventReClick class="rebtn" size="small"
								:disabled="updateFlg || addFlg || againFlg" @click="resetFormData()">重置</el-button>
						</el-col>
					</el-row>
				</el-form>
			</el-row>
		</el-card>
		<div>
			<el-card style="margin-top: -30px;" body-style="padding: 0;">
				<el-row style="margin-bottom: 10px;">
					<el-col :span="24">
						<div class="box">
							<el-table :height="getTableHeight()" :row-style="selectRowBackground" :key="tableKey"
								:row-class-name="tableRowClassName" ref="dataListTable" class="dataListTable"
								:data="dataList" header-align="center" header-cell-class-name="dataListTHeader"
								@selection-change="handleSelectionChange" :cell-style="{ padding: '0px' }"
								style="margin-bottom: 20px;" @sort-change="sortByColumn">
								<el-table-column type="selection" width="45" align="center"
									:selectable="selectable"></el-table-column>
								<el-table-column label="NO." width="90" align="center" prop="recSortCode" fixed="left">
									<template slot-scope="scope">
										<span>{{ scope.row.recSortCode }}</span>
										<!-- <el-input class="sp-input small-input" v-if="getDisabled(scope.row.testId)"
											:disabled="true" v-model="scope.row.recSortCode"></el-input> -->
									</template>
								</el-table-column>
								<el-table-column prop="partsName" label="部件" align="left" min-width="150" fixed="left"
									show-overflow-tooltip>
									<template slot-scope="scope">
										<span
											v-if="!getDisabled(scope.row.testId) && !getOtherFieldSpan(scope.row.testId)"
											@click="lookInfoHandle(scope.row.testId)">{{ scope.row.partsName }}</span>
										<el-input class="sp-input small-input" v-if="getDisabled(scope.row.testId)"
											v-model="scope.row.partsName" :disabled="againFlg"></el-input>
										<span v-if="getOtherFieldSpan(scope.row.testId)"
											style="color: #1f30ff;cursor:pointer;">{{ scope.row.partsName }}</span>
									</template>
								</el-table-column>
								<el-table-column prop="probContext" label="检验项目" align="left" min-width="250"
									fixed="left" show-overflow-tooltip>
									<template slot-scope="scope">
										<span style="line-height: 15px; white-space: pre-line; text-align: left;cursor: pointer;"
											v-if="!getDisabled(scope.row.testId) && !getOtherFieldSpan(scope.row.testId)"
											@click="lookInfoHandle(scope.row.testId)">{{ scope.row.probContext }}</span>
										<el-input class="sp-input small-input" v-if="getDisabled(scope.row.testId)"
											v-model="scope.row.probContext" :disabled="againFlg"></el-input>
										<span v-if="getOtherFieldSpan(scope.row.testId)"
											style="color: #1f30ff;cursor:pointer;">{{ scope.row.probContext }}</span>
									</template>
								</el-table-column>
								<el-table-column prop="sutContent" label="检验意见" min-width="350" align="left"
									header-align="left">
									<template slot-scope="scope">
										<!-- 正常显示或封闭状态 -->
										<div style="line-height: 15px; white-space: pre-line; text-align: left;"
											v-if="!getDisabled(scope.row.testId) && !getOtherFieldSpan(scope.row.testId)">
											{{ scope.row.sutContent }}
										</div>
										<!-- 修改状态下的输入框 -->
										<el-input type="textarea" class="sp-input" v-if="getDisabled(scope.row.testId)"
											v-model="scope.row.sutContent"
											:autosize="{ minRows: 1, maxRows: 10 }"></el-input>
										<!-- 封闭状态下显示span -->
										<div style="line-height: 15px; white-space: pre-line; text-align: left;"
											v-if="getOtherFieldSpan(scope.row.testId)">
											{{ scope.row.sutContent }}
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="testConclusionName" label="检验结论" align="center" width="120">
									<el-table-column label="1次检验" align="center" width="100px">
										<template slot-scope="scope">
											<!-- 正常显示或封闭状态 -->
											<span
												v-if="!getDisabled(scope.row.testId) && !getOtherFieldSpan(scope.row.testId)"
												:class="getConclusionClass(scope.row.testConclusion)">
												{{ scope.row.testConclusionName }}
											</span>
											<!-- 修改状态下的选择框 -->
											<el-select class="sp-input small-select right-arrow"
												v-model="scope.row.testConclusion" placeholder="请选择"
												v-if="getDisabled(scope.row.testId)" style="width:125px" clearable
												:disabled="!containCode(scope.row.recSortCode, ' ')">
												<el-option v-for="item in conclusionList" :key="item.displayValue"
													:label="item.displayName" :value="item.displayValue">
												</el-option>
											</el-select>
											<!-- 封闭状态下显示span -->
											<span v-if="getOtherFieldSpan(scope.row.testId)"
												:class="getConclusionClass(scope.row.testConclusion)">
												{{ scope.row.testConclusionName }}
											</span>
										</template>
									</el-table-column>

									<el-table-column label="2次检验" align="center" width="100px">
										<template slot-scope="scope">
											<!-- 正常显示或封闭状态 -->
											<span
												v-if="!getDisabled(scope.row.testId) && !getOtherFieldSpan(scope.row.testId)"
												:class="getConclusionClass(scope.row.testConclusion2)">
												{{ scope.row.testConclusionName2 }}
											</span>
											<!-- 修改状态下的选择框 -->
											<el-select class="sp-input small-select right-arrow"
												v-model="scope.row.testConclusion2" placeholder="请选择"
												v-if="getDisabled(scope.row.testId)" style="width:125px" clearable
												:disabled="!containCode(scope.row.recSortCode, 'A')">
												<el-option v-for="item in conclusionList" :key="item.displayValue"
													:label="item.displayName" :value="item.displayValue">
												</el-option>
											</el-select>
											<!-- 封闭状态下显示span -->
											<span v-if="getOtherFieldSpan(scope.row.testId)"
												:class="getConclusionClass(scope.row.testConclusion2)">
												{{ scope.row.testConclusionName2 }}
											</span>
										</template>
									</el-table-column>

									<el-table-column label="2次以上检验" align="center" width="110px">
										<template slot-scope="scope">
											<!-- 正常显示或封闭状态 -->
											<span
												v-if="!getDisabled(scope.row.testId) && !getOtherFieldSpan(scope.row.testId)"
												:class="getConclusionClass(scope.row.testConclusion3)">
												{{ scope.row.testConclusionName3 || scope.row.testConclusion3 }}
											</span>
											<!-- 修改状态下的选择框 - 使用过滤后的列表，排除"修正后复检"和"不接受"选项 -->
											<el-select class="sp-input small-select right-arrow"
												v-model="scope.row.testConclusion3" placeholder="请选择"
												v-if="getDisabled(scope.row.testId)" style="width:125px" clearable
												:disabled="!containCode(scope.row.recSortCode, 'B')">
												<el-option v-for="item in conclusionList" :key="item.displayValue"
													:label="item.displayName" :value="item.displayValue">
												</el-option>
											</el-select>
											<!-- 封闭状态下显示span -->
											<span v-if="getOtherFieldSpan(scope.row.testId)"
												:class="getConclusionClass(scope.row.testConclusion3)">
												{{ scope.row.testConclusionName3 || scope.row.testConclusion3 }}
											</span>
										</template>
									</el-table-column>
								</el-table-column>
								<el-table-column prop="testDate" label="检验日期" width="120" align="center"
									sortable='testDate'>
									<!-- <el-table-column prop="testDate" label="检验日期" width="120" align="center"> -->
									<template slot-scope="scope">
										<!-- 正常显示或封闭状态 -->
										<span style="margin-left: 15px;"
											v-if="!getDisabled(scope.row.testId) && !getOtherFieldSpan(scope.row.testId)">
											{{ scope.row.testDate }}
										</span>
										<!-- 修改状态下的日期选择器 -->
										<el-date-picker class="sp-input small-date-picker" v-model="scope.row.testDate"
											type="date" value-format="yyyy-MM-dd" placeholder="选择日期"
											style="width: 140px;" v-if="getDisabled(scope.row.testId)">
										</el-date-picker>
										<!-- 封闭状态下显示span -->
										<span style="margin-left: 15px;" v-if="getOtherFieldSpan(scope.row.testId)">
											{{ scope.row.testDate }}
										</span>
									</template>
								</el-table-column>
								<el-table-column prop="testMan" label="检验人" align="center" width="64">
									<template slot-scope="scope">
										<!-- 正常显示或封闭状态 -->
										<span
											v-if="!getDisabled(scope.row.testId) && !getOtherFieldSpan(scope.row.testId)">
											{{ scope.row.testMan }}
										</span>
										<!-- 修改状态下的输入框 -->
										<el-input class="sp-input small-input" v-if="getDisabled(scope.row.testId)"
											v-model="scope.row.testMan"></el-input>
										<!-- 封闭状态下显示span -->
										<span v-if="getOtherFieldSpan(scope.row.testId)">
											{{ scope.row.testMan }}
										</span>
									</template>
								</el-table-column>
								<el-table-column prop="tracking" label="跟踪情况" align="center" width="240">
									<template slot-scope="scope">
										<div style="line-height: 15px; white-space: pre-line; text-align: left;">
											{{ scope.row.tracking }}
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="scope.row.closeTime" label="封闭日期" width="114" align="center">
									<template slot-scope="scope">
										<!-- 正常显示或修改状态 -->
										<span style="margin-left: 15px;"
											v-if="!getCloseDisabled(scope.row.testId) && !getCloseFieldSpan(scope.row.testId)">
											{{ scope.row.closeTime | formatDate('yyyy-MM-dd') }}
										</span>
										<span style="margin-left: 15px;" v-if="!getCloseDisabled(scope.row.testId) && !getCloseFieldSpan(scope.row.testId)
											&& scope.row.closeTime == null && scope.row.finalTestConclusion != '2'">
											/
										</span>
										<!-- 封闭状态下的日期选择器 -->
										<el-date-picker class="sp-input small-date-picker" v-model="scope.row.closeTime"
											type="date" value-format="yyyy-MM-dd" placeholder="选择日期"
											style="width: 140px;" v-if="getCloseDisabled(scope.row.testId)">
										</el-date-picker>
										<!-- 修改状态下显示span -->
										<span style="margin-left: 15px;" v-if="getCloseFieldSpan(scope.row.testId)">
											{{ scope.row.closeTime | formatDate('yyyy-MM-dd') }}
										</span>
										<span style="margin-left: 15px;" v-if="getCloseFieldSpan(scope.row.testId)
											&& scope.row.closeTime == null && scope.row.finalTestConclusion != '2'">
											/
										</span>
									</template>
								</el-table-column>
								<el-table-column prop="closeMan" label="封闭人" align="center" width="64"
									show-overflow-tooltip>
									<template slot-scope="scope">
										<!-- 正常显示或修改状态 -->
										<span
											v-if="!getCloseDisabled(scope.row.testId) && !getCloseFieldSpan(scope.row.testId)">
											{{ scope.row.closeMan }}
										</span>
										<span v-if="!getCloseDisabled(scope.row.testId) && !getCloseFieldSpan(scope.row.testId)
											&& scope.row.finalTestConclusion != '2' && (scope.row.closeMan == '' || scope.row.closeMan == null)">
											/
										</span>
										<!-- 封闭状态下的输入框 -->
										<el-input class="sp-input small-input" v-if="getCloseDisabled(scope.row.testId)"
											v-model="scope.row.closeMan"></el-input>
										<!-- 修改状态下显示span -->
										<span v-if="getCloseFieldSpan(scope.row.testId)">
											{{ scope.row.closeMan }}
										</span>
										<span v-if="getCloseFieldSpan(scope.row.testId)
											&& scope.row.finalTestConclusion != '2' && (scope.row.closeMan == '' || scope.row.closeMan == null)">
											/
										</span>
									</template>
								</el-table-column>
								<el-table-column prop="closeDescribe" label="封闭时描述（如有时）" align="center" width="240">
									<template slot-scope="scope">
										<!-- 正常显示或修改状态 -->
										<div style="line-height: 15px; white-space: pre-line; text-align: left;"
											v-if="!getCloseDisabled(scope.row.testId) && !getCloseFieldSpan(scope.row.testId)">
											{{ scope.row.closeDescribe }}
										</div>
										<div
											v-if="!getCloseDisabled(scope.row.testId) && !getCloseFieldSpan(scope.row.testId)
												&& scope.row.finalTestConclusion != '2' && (scope.row.closeDescribe == '' || scope.row.closeDescribe == null)">
											/
										</div>
										<!-- 封闭状态下的输入框 -->
										<el-input class="sp-input small-input" v-if="getCloseDisabled(scope.row.testId)"
											v-model="scope.row.closeDescribe"></el-input>
										<!-- 修改状态下显示span -->
										<div style="line-height: 15px; white-space: pre-line; text-align: left;"
											v-if="getCloseFieldSpan(scope.row.testId)">
											{{ scope.row.closeDescribe }}
										</div>
										<div
											v-if="getCloseFieldSpan(scope.row.testId)
												&& scope.row.finalTestConclusion != '2' && (scope.row.closeDescribe == '' || scope.row.closeDescribe == null)">
											/
										</div>
									</template>
								</el-table-column>
								<el-table-column prop="remark" label="备注" align="center" width="200">
									<template slot-scope="scope">
										<!-- 正常显示或修改状态 -->
										<div style="line-height: 15px; white-space: pre-line; text-align: left;"
											v-if="!getCloseDisabled(scope.row.testId) && !getCloseFieldSpan(scope.row.testId)">
											{{ scope.row.remark }}
										</div>
										<!-- 封闭状态下的输入框 -->
										<el-input class="sp-input small-input" v-if="getCloseDisabled(scope.row.testId)"
											v-model="scope.row.remark"></el-input>
										<!-- 修改状态下的输入框（备注在修改状态下也可编辑） -->
										<el-input class="sp-input small-input" v-if="getDisabled(scope.row.testId)"
											v-model="scope.row.remark"></el-input>
									</template>
								</el-table-column>

								<el-table-column prop="remark" label="程度" align="center" width="100"
									show-overflow-tooltip>
									<template slot-scope="scope">
										<el-switch v-model="scope.row.primaryFlg" active-value="1" inactive-value="0"
											active-text="主要" @change="updatePrimaryFlg(scope.row.testId)">
										</el-switch>
									</template>
								</el-table-column>

								<el-table-column label="操作" width="210" align="left"
									v-if="showDelete || showEdit || showLook" fixed="right">
									<template slot-scope="scope">
										<!-- <el-button v-preventReClick type="text" size="mini"
											@click="updateHandle(scope.row.testId)" v-if="showEdit && !updateFlg && !addFlg && !againFlg && !closeFlg
												&& getShowButton(scope.row) && scope.row.closeState != '2'">修改</el-button> -->
										<el-button v-preventReClick type="text" size="mini"
											@click="addOrUpdateHandle(scope.row.testId)" v-if="showEdit && !updateFlg && !addFlg && !againFlg && !closeFlg
												&& getShowButton(scope.row) && scope.row.closeState != '2'">修改</el-button>
										<el-button v-preventReClick type="text" size="mini"
											@click="trackingHandle(scope.row.testId)"
											v-if="showEdit && !updateFlg && !addFlg && !againFlg && scope.row.closeState != '2'">跟踪意见</el-button>
										<!-- <el-button v-preventReClick type="text" size="mini"
										@click="deleteHandle(scope.row.testId)"
										v-if="showDelete && !updateFlg && !addFlg && !againFlg">删除</el-button> -->
										<el-button v-preventReClick type="text" size="mini"
											@click="picAndFileHandle(scope.row.testId)"
											v-if="!updateFlg && !addFlg && !againFlg && !closeFlg">照片</el-button>
										<el-button v-preventReClick type="text" size="mini"
											@click="closeProblemHandle(scope.row.testId)"
											v-if="!updateFlg && !addFlg && !againFlg && scope.row.finalTestConclusion == '2' && scope.row.closeState == '1'"">确认封闭</el-button>
										<el-button v-preventReClick type="text" size="mini"
											v-if="!updateFlg && !addFlg && scope.row.finalTestConclusion == '2' && scope.row.closeState == '2' && !updateFlg && !addFlg && !againFlg"
											@click="cancelCloseHandle(scope.row.testId)">解除封闭</el-button>
										<!-- <el-button v-preventReClick type="text" size="mini"
											@click="againHandle(scope.row.testId)" v-if="showAdd && scope.row.closeState == '1' && (scope.row.finalTestConclusion == '1' || scope.row.finalTestConclusion == '3')
												&& scope.row.testTimes != '3' && !updateFlg && !addFlg && !againFlg && !closeFlg">复检</el-button> -->
										<el-button v-preventReClick type="text" size="mini"
											@click="againNewHandle(scope.row.testId)" v-if="showAdd && scope.row.closeState == '1' && (scope.row.finalTestConclusion == '1' || scope.row.finalTestConclusion == '3')
												&& scope.row.testTimes != '3' && !updateFlg && !addFlg && !againFlg && !closeFlg">复检</el-button>
										<!--新增和复检时按钮-->
										<el-button v-preventReClick type="text" size="small" @click="saveTestRecord()"
											v-if="scope.row.testId == undefined && (addFlg || againFlg)">保存</el-button>
										<el-button v-preventReClick type="text" size="small" @click="cancelSaveHandle()"
											v-if="scope.row.testId == undefined && (addFlg || againFlg)">取消</el-button>
										<!--修改和封闭时按钮-->
										<el-button v-preventReClick type="text" size="small"
											@click="updateTestRecord(scope.row)"
											v-if="(getDisabled(scope.row.testId) || getCloseDisabled(scope.row.testId)) && !addFlg && !againFlg">保存</el-button>
										<el-button v-preventReClick type="text" size="small"
											@click="cancelUpdateHandle()"
											v-if="(getDisabled(scope.row.testId) || getCloseDisabled(scope.row.testId)) && !addFlg && !againFlg">取消</el-button>
									</template>
								</el-table-column>
							</el-table>
						</div>
						<el-pagination class="my-pagination" @size-change="sizeChangeHandle"
							@current-change="currentChangeHandle" :current-page="pageIndex"
							:page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage"
							layout="total, sizes, prev, pager, next, jumper"
							:disabled="updateFlg || addFlg || againFlg">
						</el-pagination>
					</el-col>
				</el-row>
			</el-card>

			<el-dialog title="NO连续性检查" :visible.sync="checkVisible" width="600px" :close-on-click-modal="false">
				<!-- 内容区 -->
				<div class="check-content">
					<!-- 项目卡片 -->
					<div v-for="(subRecord, index) in noContinuityCheckList" :key="'sub' + index" class="project-card">
						<!-- 项目头部 -->
						<div class="project-header">
							<div class="project-badge">
								<span class="project-no">{{ subRecord.projectNo }}</span>
							</div>
							<span class="project-stats">{{ getMissingTotal(subRecord) }}个缺失</span>
						</div>

						<!-- 专业列表 -->
						<div class="majors-container">
							<div v-for="(majRecord, index1) in subRecord.majRecordList" :key="'maj' + index1"
								class="major-block">
								<div class="major-title">
									<span class="major-name">{{ majRecord.majorName }}</span>
									<span class="missing-count">({{ majRecord.missingNums.length }})</span>
								</div>

								<!-- 缺失数字（固定宽度按钮） -->
								<div class="missing-grid">
									<button v-for="(recSortNum, index2) in majRecord.missingNums" :key="'miss' + index2"
										class="missing-number-btn"
										@click="chooseConNumHandle(subRecord.subjectNo, majRecord.major, recSortNum)">
										{{ recSortNum }}
									</button>
								</div>
							</div>
						</div>
					</div>

					<!-- 空状态 -->
					<div v-if="!noContinuityCheckList || noContinuityCheckList.length === 0" class="empty-state">
						<span>暂无缺失数据</span>
					</div>
				</div>
			</el-dialog>
		</div>
		<add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="dataList"></add-or-update>
		<update v-if="updateVisible" ref="update" @refreshDataList="dataList"></update>
		<add-again v-if="againVisible" ref="addAgain" @refreshDataList="dataList"></add-again>
		<audit v-if="auditVisible" ref="audit" @refreshDataList="dataList"></audit>
		<change-conclusion v-if="changeConclusionVisible" ref="changeConclusion"
			@refreshDataList="dataList"></change-conclusion>
		<look v-if="lookVisible" ref="look"></look>
		<excel-upload v-if="excelUploadVisible" ref="excelUpload" @refreshDataList="getDataList"></excel-upload>
		<pic-and-file v-if="picAndFileVisible" ref="picAndFile" @refreshDataList="getDataList"></pic-and-file>
		<information-info v-if="lookInfoVisible" ref="informationInfo"></information-info>
		<close-problem v-if="closeProblemVisible" ref="closeProblem" @refreshDataList="getDataList"></close-problem>
		<tracking v-if="showTracking" ref="tracking" @refreshDataList="getDataList"></tracking>
	</div>
</template>
<script>
import AddOrUpdate from './information-add-or-update'
import ChangeConclusion from './information-change-conclusion'
import CloseProblem from './close-problem'
import Update from './information-update'
import AddAgain from './information-again'
import $common from "@/utils/common.js"
import ExcelUpload from './information-excel-upload'
import audit from './information-audit'
import look from './information-look'
import PicAndFile from './information-pic-and-file'
import InformationInfo from "./information-info"
import Tracking from './tracking'
export default {
	data() {
		return {
			tableKey: 0, // 新增
			showSearch: false,
			showAdd: false,
			closeProblemVisible: false,
			cancelProblemVisible: false,
			showSelect: false,
			showDelete: false,
			showApply: false,
			showAccept: false,
			showConfirm: false,
			showEdit: false,
			showLook: false,
			pageSpan: 12,
			partsName: '',
			probContext: '',
			sutContent: '',
			tabIndex: "0",
			showSubject: false,
			closeStateList: [{
				label: '未封闭',
				value: '0'
			}, {
				label: '已封闭',
				value: '1'
			}, {
				label: '待检',
				value: '2'
			}],
			primaryLabelList: [],
			addOrUpdateVisible: false,
			excelUploadVisible: false,
			updateVisible: false,
			againVisible: false,
			auditVisible: false,
			closeFlg: false,
			lookVisible: false,
			lookInfoVisible: false,
			changeConclusionVisible: false,
			disabledBatchDelete: true,
			picAndFileVisible: false,
			updateFlg: false,
			addFlg: false,
			againFlg: false,
			showTracking: false,
			checkVisible: false,
			tableSelVals: [],
			form: {},
			//当前页码
			pageIndex: 1,
			//当前记录数
			pageSize: 20,
			//总页数
			totalPage: 0,

			selAllFlg: false,
			workNo: $common.getItem("workNo"),
			tableSelVal: [],
			tableSelIdArray: [],
			majorList: [],
			major: "",
			closeState: '',
			primaryFlg: '',
			subjectNo: "",
			Majorgory: 0,
			recSortCode: '',
			category: "",
			SubjectDropList: [],
			Subject: "",
			dataList: [],
			//结论
			testConclusion: "",
			//
			conclusionList: [],
			selectConclusionList: [],
			statusList: [],
			//状态
			state: "",
			testDate: [],
			recNos: [],
			dataTotal: {
				testConclusionNum: 0,
				testConclusionRefuseNum: 0,
				recheckAfterCorrectionNum: 0,
				testConclusionWhereNum: 0
			},
			oldAgainTestId: '',
			title: '',
			subjectList: [],
			screenHeight: 0,
			closeStateList: [
				{
					label: '全部',
					value: ''
				},
				{
					label: '已封闭',
					value: '1'
				},
				{
					label: '未封闭',
					value: '0'
				},
				// {
				// 	label: '待检',
				// 	value: '2'
				// },
			],
			primaryLabelList: [
				{
					label: '全部',
					value: ''
				},
				{
					label: '主要',
					value: '1'
				},
				{
					label: '正常',
					value: '0'
				},
			],
			noContinuityCheckList: [],
			queryTableForm: {
				orderColumn: '',
				orderWay: '',
			},
		};
	},
	computed: {
		// 过滤后的检验结论列表，用于"2次以上检验"下拉框，排除"修正后复检"和"不接受"
		filteredConclusionList() {
			return this.conclusionList.filter(item => {
				// 根据displayValue过滤，排除值为'3'(修正后复检)和'1'(不接受)的选项
				return item.displayValue !== '3' && item.displayValue !== '1';
			});
		}
	},
	components: {
		AddOrUpdate,
		audit,
		look,
		Update,
		AddAgain,
		ChangeConclusion,
		CloseProblem,
		ExcelUpload,
		PicAndFile,
		InformationInfo,
		Tracking
	},
	mounted() {
		this.screenHeight = window.innerHeight
		this.category = this.$route.query.type;
		if (this.category === '1') {
			this.title = '质量报验'
		} else if (this.category === '2') {
			this.title = '安全报验'
		}
		this.showSearch = $common.isAuth('information:search:' + this.category);
		this.showAdd = $common.isAuth('information:add:' + this.category);
		this.showSelect = $common.isAuth('information:select:' + this.category);
		this.showDelete = $common.isAuth('information:delete:' + this.category);
		this.showApply = $common.isAuth('information:apply:' + this.category);
		this.showAccept = $common.isAuth('information:accept:' + this.category);
		this.showConfirm = $common.isAuth('information:confirm:' + this.category);
		this.showEdit = $common.isAuth('information:edit:' + this.category);
		this.showLook = $common.isAuth('information:look:' + this.category);
		if (!this.showAdd && !this.showSelect && !this.showDelete) {
			this.pageSpan = 24;
		}
		// if (this.showSearch) {
		// 	this.getDataList();
		// }
		this.getAllSubjectDropDown()
		this.getAllMajorList();
		this.getInspectionStatus();
		this.getInspectionConclusion();
	},
	filters: {
		formatDate: function (value, args) {
			if (!value) {
				return ''
			}
			var dt = new Date(value);
			if (args == 'yyyy-M-d') {// yyyy-M-d
				let year = dt.getFullYear();
				let month = dt.getMonth() + 1;
				let date = dt.getDate();
				return `${year}-${month}-${date}`;
			} else if (args == 'yyyy-M-d H:m:s') {// yyyy-M-d H:m:s
				let year = dt.getFullYear();
				let month = dt.getMonth() + 1;
				let date = dt.getDate();
				let hour = dt.getHours();
				let minute = dt.getMinutes();
				let second = dt.getSeconds();
				return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
			} else if (args == 'yyyy-MM-dd') {// yyyy-MM-dd
				let year = dt.getFullYear();
				let month = (dt.getMonth() + 1).toString().padStart(2, '0');
				let date = dt.getDate().toString().padStart(2, '0');
				return `${year}-${month}-${date}`;
			} else {// yyyy-MM-dd HH:mm:ss
				let year = dt.getFullYear();
				let month = (dt.getMonth() + 1).toString().padStart(2, '0');
				let date = dt.getDate().toString().padStart(2, '0');
				let hour = dt.getHours().toString().padStart(2, '0');
				let minute = dt.getMinutes().toString().padStart(2, '0');
				let second = dt.getSeconds().toString().padStart(2, '0');
				return `${year}-${month}-${date} ${hour}:${minute}:${second}`;
			}
		}
	},
	methods: {
		getTableHeight() {
			let majorHeight = 0;
			if (this.majorList.length > 5) {
				majorHeight = 27;
			}
			if (this.showSubject) {
				return this.screenHeight - 328 - majorHeight + 'px';
			}
			return this.screenHeight - 295 - majorHeight + 'px';
		},
		getCurrentTime() {
			//获取当前时间并打印
			var _this = this;
			let yy = new Date().getFullYear();
			let mm = new Date().getMonth() + 1;
			let dd = new Date().getDate();
			let hh = new Date().getHours();
			let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
			let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
			return yy + '-' + mm + '-' + dd;
		},

		containCode(recSortCode, code) {
			var sortCode = recSortCode + "";
			var numReg = /^[0-9]+$/
			var numRe = new RegExp(numReg)
			if (numRe.test(sortCode) && code == ' ') {
				return true;
			} else if (sortCode.indexOf(code) != -1) {
				return true;
			} else {
				return false;
			}
		},
		getShowButton(item) {
			if ((item.finalTestConclusion == '1' || item.finalTestConclusion == '3') && item.closeState == '2') {
				// 修改按钮不显示
				return false;
			}
			return true;
		},
		isClose(row) {
			return row.problem != null && row.problem.closeTime != null;
		},
		neetClose(row) {
			return row.testConclusion == '2' && row.problem.probId != null && row.problem.closeTime == null;
		},
		handleChange(testId, index) {
			if (testId === undefined) {
				if (this.dataList[0].subjectNo && this.dataList[0].major) {
					this.getNextRecCode("0");
				}
			} else {
				if (this.dataList[index].subjectNo && this.dataList[index].major) {
					this.getNextRecCode(index);
				}
			}
		},
		// 计算项目的缺失总数（可选）
		getMissingTotal(subRecord) {
			if (!subRecord.majRecordList) return 0;
			return subRecord.majRecordList.reduce((total, maj) => {
				return total + (maj.missingNums?.length || 0);
			}, 0);
		},
		checkHandle() {
			if (this.subjectNo == undefined || this.subjectNo == '') {
				this.$message.error("请选择标的物！")
				return;
			}
			if (this.major == undefined || this.major == '') {
				this.$message.error("请选择专业！")
				return;
			}
			let _url = "/business/testrecord/getNoContinuityCheckList";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "get",
				params: this.$http.adornParams({
					workNo: $common.getItem("workNo"),
					category: this.category,
					subjectNo: this.subjectNo,
					major: this.major,
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					if (!data.body || !data.body.subRecordList || data.body.subRecordList.length === 0) {
						this.$message.error('没有可操作数据！')
					} else {
						this.noContinuityCheckList = data.body.subRecordList
						this.checkVisible = true
					}
				}
			})
		},
		chooseConNumHandle(subjectNo, major, recSortNum) {
			this.addOrUpdateVisible = true;
			this.$nextTick(() => {
				this.$refs.addOrUpdate.init('', this.category, subjectNo, major, recSortNum)
			})
			this.checkVisible = false;
		},
		// chooseConNumHandle(subjectNo, major, recSortNum) {
		// 	// 首行新增一条记录
		// 	let dataList = [];
		// 	let testRecord = {
		// 		workNo: $common.getItem("workNo"),
		// 		subjectNo: subjectNo,
		// 		major: major,
		// 		category: this.category,
		// 		recSortCode: recSortNum,
		// 		probContext: '',
		// 		sutContent: '',
		// 		partsName: '',
		// 		testConclusion: '',
		// 		testConclusion2: '',
		// 		testConclusion3: '',
		// 		testDate: this.getCurrentTime(),
		// 		testMan: $common.getItem("userName"),
		// 		tracking: '',
		// 		closeTime: '',
		// 		closeMan: '',
		// 		remark: '',
		// 	}
		// 	dataList.push(testRecord);
		// 	for (var i = 0; i < this.dataList.length; i++) {
		// 		dataList.push(this.dataList[i])
		// 	}
		// 	this.dataList = dataList
		// 	this.addFlg = true;
		// 	this.checkVisible = false;
		// },
		addOrUpdateHandle(id) {
			if (id == null || id == undefined) {
				if (this.subjectNo == undefined || this.subjectNo == '') {
					this.$message.error("请选择标的物！")
					return;
				}
				if (this.major == undefined || this.major == '') {
					this.$message.error("请选择专业！")
					return;
				}
			}
			this.addOrUpdateVisible = true;
			this.$nextTick(() => {
				this.$refs.addOrUpdate.init(id, this.category, this.subjectNo, this.major, '')
			})
		},
		addHandle() {
			if (this.subjectNo == undefined || this.subjectNo == '') {
				this.$message.error("请选择标的物！")
				return;
			}
			if (this.major == undefined || this.major == '') {
				this.$message.error("请选择专业！")
				return;
			}
			let _url = "/business/testrecord/getLastRecord";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					workNo: $common.getItem("workNo"),
					category: this.category,
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					// 首行新增一条记录
					let dataList = [];
					var nextRecCode = 0;
					let testRecord = {
						workNo: $common.getItem("workNo"),
						subjectNo: this.subjectNo,
						major: this.major,
						category: this.category,
						recSortCode: nextRecCode,
						probContext: '',
						sutContent: '',
						partsName: '',
						testConclusion: '',
						testConclusion2: '',
						testConclusion3: '',
						testDate: this.getCurrentTime(),
						testMan: $common.getItem("userName"),
						tracking: '',
						closeTime: '',
						closeMan: '',
						remark: '',
					}
					dataList.push(testRecord);
					for (var i = 0; i < this.dataList.length; i++) {
						dataList.push(this.dataList[i])
					}
					this.dataList = dataList
					this.addFlg = true;
					this.getNextRecCode(0);
				}
			});
		},
		getNextRecCode(index) {
			let _url = "/business/testrecord/getNextRecCode";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					workNo: $common.getItem("workNo"),
					subjectNo: this.dataList[index].subjectNo,
					major: this.dataList[index].major,
					category: this.category,
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$set(this.dataList[index], 'recSortCode', data.body)
					if (this.dataList[index].recSortCode === '') {
						this.dataList[index].recSortCode = '1'
					}
				}
			});
		},
		cancelSaveHandle() {
			this.addFlg = false;
			this.againFlg = false;
			// this.oldAgainTestId = '';
			let dataList = [];
			for (var i = 0; i < this.dataList.length; i++) {
				if (this.dataList[i].testId != undefined) {
					dataList.push(this.dataList[i])
				}
			}
			this.dataList = dataList
		},
		updateHandle(testId) {
			this.recNos.push(testId);
			this.updateFlg = true;
			this.closeFlg = false; // 确保不是封闭状态
		},
		trackingHandle(id) {
			this.showTracking = true;
			this.$nextTick(() => {
				this.$refs.tracking.init(id)
			})
		},
		cancelUpdateHandle() {
			this.getDataList();
			this.recNos = [];
			this.updateFlg = false;
			this.closeFlg = false;
		},
		// 判断是否可编辑 - 修改时用
		getDisabled(val) {
			if (val == '' || val == undefined) {
				return true;
			} else {
				// 只在修改状态下才可编辑
				if (this.recNos.includes(val) && this.updateFlg) {
					return true;
				}
				return false;
			}
		},

		// 判断封闭字段是否可编辑 - 只有封闭状态下可编辑
		getCloseDisabled(val) {
			if (val == '' || val == undefined) {
				return false;
			} else {
				// 只在封闭状态下才可编辑
				if (this.recNos.includes(val) && this.closeFlg) {
					return true;
				}
				return false;
			}
		},
		// 封闭状态下其他字段是否显示span
		getOtherFieldSpan(val) {
			if (val == '' || val == undefined) {
				return false;
			} else {
				// 如果是在封闭状态下，其他字段显示span
				if (this.recNos.includes(val) && this.closeFlg) {
					return true;
				}
				return false;
			}
		},
		// 修改状态下封闭字段是否显示span
		getCloseFieldSpan(val) {
			if (val == '' || val == undefined) {
				return false;
			} else {
				// 如果是在修改状态下，封闭字段显示span
				if (this.recNos.includes(val) && this.updateFlg) {
					return true;
				}
				return false;
			}
		},
		closeProblemHandle(testId) {
			// this.recNos.push(testId);
			// this.closeFlg = true;
			// this.updateFlg = false; // 确保不是修改状态
			this.closeProblemVisible = true
			this.$nextTick(() => {
				this.$refs.closeProblem.init(testId)
			})
		},
		againNewHandle(id) {
			this.againVisible = true;
			this.$nextTick(() => {
				this.$refs.addAgain.init(id, this.category)
			})
		},
		againHandle(testId) {
			this.oldAgainTestId = testId;
			this.$http({
				url: this.$store.state.httpUrl + "/business/testrecord/info/" + testId,
				method: "get",
				params: {},
			}).then(({
				data
			}) => {
				if (data && data.resultCode === 200) {
					let dataList = [];
					let testRecord = {
						workNo: $common.getItem("workNo"),
						subjectNo: data.body.subjectNo,
						subjectName: data.body.subjectName,
						major: data.body.major,
						majorName: data.body.majorName,
						category: this.category,
						recSortCode: data.body.nextSortCode,
						probContext: data.body.probContext,
						sutContent: '',
						partsName: data.body.partsName,
						testConclusion: '',
						testConclusion2: '',
						testConclusion3: '',
						testDate: this.getCurrentTime(),
						testMan: data.body.testMan,
						tracking: '',
						closeTime: '',
						closeMan: '',
						remark: '',
						oldAgainTestId: testId
					}
					dataList.push(testRecord);
					for (var i = 0; i < this.dataList.length; i++) {
						dataList.push(this.dataList[i])
					}
					this.dataList = dataList
					this.againFlg = true;
				}
			});
		},
		cancelCloseHandle(testId) {
			this.$confirm(`确定要解除封闭吗？`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + "/business/testrecord/cancelCloseTestRecord/" + testId,
					method: 'post',
					params: {}
				}).then(({
					data
				}) => {
					if (data && data.resultCode === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
						})
						this.getDataList();
					}
				})
			});
		},
		closeProblemHandle(id) {
			this.closeProblemVisible = true
			this.$nextTick(() => {
				this.$refs.closeProblem.init(id)
			})
		},
		cancelProblemHandle(id) {
			this.cancelProblemVisible = true
			this.$nextTick(() => {
				this.$refs.cancelProblem.init(id)
			})
		},
		selectable(row) {
			return true;  //不禁用
		},
		uploadHandle() {
			this.excelUploadVisible = true;
			this.$nextTick(() => {
				this.$refs.excelUpload.init(this.category)
			})
		},
		downloadHandle() {
			const rLoading = this.openLoading();
			this.$http({
				url: this.$store.state.httpUrl + "/business/testrecord/download",
				method: 'get',
				params: this.$http.adornParams({
					major: this.major,
					subjectNo: this.subjectNo,
					state: this.state,
					testDateBegin: this.testDate && this.testDate[0] ? this.testDate[0] : "",
					testDateEnd: this.testDate && this.testDate[1] ? this.testDate[1] : "",
					testConclusion: this.testConclusion,
					category: this.category,
					probContext: this.probContext,
					closeState: this.closeState,
					primaryFlg: this.primaryFlg,
					workNo: $common.getItem("workNo"),
					recSortCode: this.recSortCode,
				})
			}).then(({ data }) => {
				rLoading.close();
				if (data && data.resultCode === 200) {
					if (this.$store.state.showTestFlag) {
						window.open(data.body)
					} else {
						this.global.downLoadFile(data.body, '报验记录表.xlsx');
					}
				} else {
				}
			})
		},
		downloadTemplate() {
			this.$http({
				url: this.$store.state.httpUrl + "/common/getTemplateUrl?type=5",
				method: 'get',
				params: {}
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					if (data.body) {
						// window.open(data.body);
						if (this.$store.state.showTestFlag) {
							window.open(data.body)
						} else {
							this.global.downLoadFile(data.body, '报验记录表模板.xlsx');
						}
					} else {
						this.$message.error("未配置模板，请联系运维管理人员")
					}
				}
			});
		},
		countTestRecord() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/testrecord/countTestRecord",
				method: 'get',
				params: this.$http.adornParams({
					major: this.major,
					subjectNo: this.subjectNo,
					recSortCode: this.recSortCode,
					state: this.state,
					testDateBegin: this.testDate && this.testDate[0] ? this.testDate[0] : "",
					testDateEnd: this.testDate && this.testDate[1] ? this.testDate[1] : "",
					testConclusion: this.testConclusion,
					category: this.category,
					probContext: this.probContext,
					closeState: this.closeState,
					primaryFlg: this.primaryFlg,
					workNo: $common.getItem("workNo"),
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.dataTotal = data.body
				}
			})
		},
		cancelClose(testId) {
			this.$confirm(`确定要解除封闭吗？`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + "/business/testrecord/cancelCloseTestRecord/" + testId,
					method: 'post',
					params: {}
				}).then(({
					data
				}) => {
					if (data && data.resultCode === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
						})
						this.getDataList();
					}
				})
			});
		},
		// 获取数据列表
		getDataList() {
			this.countTestRecord()
			this.$http({
				url: this.$store.state.httpUrl + "/business/testrecord/list",
				method: 'get',
				params: this.$http.adornParams({
					page: this.pageIndex,
					major: this.major,
					subjectNo: this.subjectNo,
					recSortCode: this.recSortCode,
					state: this.state,
					testDateBegin: this.testDate && this.testDate[0] ? this.testDate[0] : "",
					testDateEnd: this.testDate && this.testDate[1] ? this.testDate[1] : "",
					testConclusion: this.testConclusion,
					category: this.category,
					partsName: this.partsName,
					probContext: this.probContext,
					sutContent: this.sutContent,
					closeState: this.closeState,
					primaryFlg: this.primaryFlg,
					limit: this.pageSize,
					workNo: $common.getItem("workNo"),
					orderColumn: this.queryTableForm.orderColumn,
					orderWay: this.queryTableForm.orderWay,
				})
			}).then(({
				data
			}) => {
				if (data && data.resultCode === 200) {
					this.dataList = data.body.records;
					this.totalPage = data.body.totalCount;
				} else {
					this.dataList = []
					this.totalPage = 0
				}
			})
		},
		sortByColumn(column) {
			this.countTestRecord()
			this.$http({
				url: this.$store.state.httpUrl + "/business/testrecord/list",
				method: 'get',
				params: this.$http.adornParams({
					page: this.pageIndex,
					major: this.major,
					subjectNo: this.subjectNo,
					recSortCode: this.recSortCode,
					state: this.state,
					testDateBegin: this.testDate && this.testDate[0] ? this.testDate[0] : "",
					testDateEnd: this.testDate && this.testDate[1] ? this.testDate[1] : "",
					testConclusion: this.testConclusion,
					category: this.category,
					partsName: this.partsName,
					probContext: this.probContext,
					sutContent: this.sutContent,
					closeState: this.closeState,
					primaryFlg: this.primaryFlg,
					limit: this.pageSize,
					workNo: $common.getItem("workNo"),
					orderColumn: column.prop,
					orderWay: column.order,
				})
			}).then(({
				data
			}) => {
				if (data && data.resultCode === 200) {
					this.dataList = data.body.records
					this.totalPage = data.body.totalCount
					this.queryTableForm.orderColumn = column.prop
					this.queryTableForm.orderWay = column.order
				} else {
					this.dataList = []
					this.totalPage = 0
					this.queryTableForm.orderColumn = column.prop
					this.queryTableForm.orderWay = column.order
				}
			})
		},
		saveTestRecord() {
			if (this.dataList[0].subjectNo == null || this.dataList[0].subjectNo == "") {
				this.$message.error("请选择标的物");
				return;
			}

			if (this.dataList[0].major == null || this.dataList[0].major == "") {
				this.$message.error("请选择专业");
				return;
			}

			if (this.dataList[0].probContext == null || this.dataList[0].probContext == "") {
				this.$message.error("请填写检验项目");
				return;
			}
			if (this.dataList[0].sutContent == null || this.dataList[0].sutContent == "") {
				this.$message.error("请填写检验意见");
				return;
			}

			var partsNameAndProbContext = this.dataList[0].partsName + this.dataList[0].probContext;
			if (partsNameAndProbContext == null || partsNameAndProbContext == '') {
				this.$message.error("部件和检验项目不能都为空！");
				return;
			}


			if (this.dataList[0].testDate == null || this.dataList[0].testDate == "") {
				this.$message.error("请填写检验时间");
				return;
			}

			if (this.dataList[0].testMan == null || this.dataList[0].testMan == "") {
				this.$message.error("请填写检验人");
				return;
			}

			if (this.dataList[0].testConclusion == '' && this.dataList[0].testConclusion2 == '' && this.dataList[0].testConclusion3 == '') {
				this.$message.error("请填写检验结论");
				return;
			}

			let _url = "/business/testrecord/saveOrUpdate";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData(this.dataList[0])
			}).then(({
				data
			}) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
					});
					this.getDataList()
					this.addFlg = false
					this.againFlg = false
				}
			});
		},
		updateTestRecord(val) {
			// 封闭状态下的验证
			if (this.closeFlg) {
				// 封闭状态下，封闭日期和封闭人必填
				if (!val.closeTime || val.closeTime === '') {
					this.$message.error("请填写封闭日期");
					return;
				}
				if (!val.closeMan || val.closeMan === '') {
					this.$message.error("请填写封闭人");
					return;
				}
			} else {
				// 修改状态下的验证（原有验证逻辑）
				if (val.subjectNo == null || val.subjectNo == "") {
					this.$message.error("请选择标的物");
					return;
				}

				if (val.major == null || val.major == "") {
					this.$message.error("请选择专业");
					return;
				}

				if (val.probContext == null || val.probContext == "") {
					this.$message.error("请填写检验项目");
					return;
				}

				if (val.sutContent == null || val.sutContent == "") {
					this.$message.error("请填写检验意见");
					return;
				}

				if (val.testDate == null || val.testDate == "") {
					this.$message.error("请填写检验时间");
					return;
				}

				if (val.testMan == null || val.testMan == "") {
					this.$message.error("请填写检验人");
					return;
				}

				if (val.testConclusion == '' && val.testConclusion2 == '' && val.testConclusion3 == '') {
					this.$message.error("请填写检验结论");
					return;
				}
			}

			var partsNameAndProbContext = val.partsName + val.probContext;
			if (partsNameAndProbContext == null || partsNameAndProbContext == '') {
				this.$message.error("部件和检验项目不能都为空！");
				return;
			}

			let _url = "/business/testrecord/saveOrUpdate";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData(val)
			}).then(({
				data
			}) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
					});
					this.getDataList();
					this.updateFlg = false;
					this.closeFlg = false;
					this.recNos = [];
				}
			});
		},
		//获取报验状态
		getInspectionStatus() {
			this.$http({
				url: this.$store.state.httpUrl + "/common/getInspectionStatus",
				method: "get",
				params: {},
			}).then(({
				data
			}) => {
				if (data && data.resultCode === 200) {
					this.statusList = data.body;
				}
			});
		},
		picAndFileHandle(id) {
			this.picAndFileVisible = true;
			this.$nextTick(() => {
				this.$refs.picAndFile.init(id)
			})
		},
		toggleAllSelection() {
			this.$refs.dataListTable.toggleAllSelection();
		},
		setMajorgory(value) {
			this.subjectNo = value;
			this.pageIndex = 1;
			this.getDataList();
		},
		getAllSubjectDropDown() {
			this.$http({
				url: this.$store.state.httpUrl + "/common/getAllSubjectDropDown/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.subjectList = data.body;
					if (this.subjectList != undefined && this.subjectList.length > 0) {
						this.subjectNo = this.subjectList[0].displayValue
						if (this.showSearch) {
							this.getDataList();
						}
					}
					if (this.subjectList != undefined && this.subjectList.length > 1) {
						this.showSubject = true
					} else {
						this.showSubject = false
					}
				}
			});
		},
		//获取专业
		getAllMajorList() {
			this.$http({
				url: this.$store.state.httpUrl + "/common/getAllMajorByWorkNo/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.majorList = data.body;
					if (this.majorList != undefined && this.majorList.length > 0) {
						this.major = this.majorList[0].displayValue
						if (this.showSearch) {
							this.getDataList();
						}
					}
				}
			});
		},
		//获取报验结论
		getInspectionConclusion() {
			this.$http({
				url: this.$store.state.httpUrl + "/common/getInspectionConclusion",
				method: "get",
				params: {},
			}).then(({
				data
			}) => {
				if (data && data.resultCode === 200) {
					// 搜索栏的检验结论条件
					this.selectConclusionList = []
					// 加全部类别
					let conclusion = {
						displayName: '全部',
						displayValue: ''
					}
					this.selectConclusionList.push(conclusion)
					if (data.body != null && data.body.length > 0) {
						for (var i = 0; i < data.body.length; i++) {
							this.selectConclusionList.push(data.body[i])
						}
					}
					// this.major = this.selectConclusionList[0].displayValue

					// table数据的检测结论条件
					this.conclusionList = data.body
				}
			});
		},
		setMajor(major) {
			if (!this.addFlg && !this.updateFlg) {
				this.major = major.displayValue
				this.getDataList()
			}
		},
		setSubject(subject) {
			if (!this.addFlg && !this.updateFlg) {
				this.subjectNo = subject.displayValue
				this.getDataList()
			}
		},
		setClo(closeState) {
			if (!this.addFlg && !this.updateFlg) {
				this.closeState = closeState.value
				this.getDataList()
			}
		},
		setPrimary(primaryFlg) {
			if (!this.addFlg && !this.updateFlg) {
				this.primaryFlg = primaryFlg.value
				this.getDataList()
			}
		},
		setCon(testConclusion) {
			if (!this.addFlg && !this.updateFlg) {
				this.testConclusion = testConclusion.displayValue
				this.getDataList()
			}
		},
		siteContentViewHeight() {
			var height = this.$store.state.common.documentClientHeight - 320;
			return {
				height: height + 'px'
			}
		},
		handleSelectionChange(selection) {
			this.tableSelVals = selection;
			if (selection.length > 0) {
				this.disabledBatchDelete = false;
			} else {
				this.disabledBatchDelete = true;
			}
		},
		changeConclusionHandle(id) {
			this.changeConclusionVisible = true;
			this.$nextTick(() => {
				this.$refs.changeConclusion.init(id)
			})
		},
		lookInfoHandle(id) {
			this.lookInfoVisible = true;
			this.$nextTick(() => {
				this.$refs.informationInfo.init(id)
			})
			// this.$router.push({ name: 'informationInfo', query: { testId: id } });
		},
		// againHandle(id) {
		// 	this.againVisible = true;
		// 	this.$nextTick(() => {
		// 		this.$refs.addAgain.init(id, this.category)
		// 	})
		// },
		// 申请检验
		applyHandle(id, name) {
			this.$confirm(`确认要进行报验申请吗?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + "/business/testrecord/updateApply",
					method: 'post',
					data: this.$http.adornData({
						testId: id
					})
				}).then(({
					data
				}) => {
					if (data && data.resultCode === 200) {
						this.$message({
							message: '申请检验成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getDataList()
							}
						})
					} else {
						this.$message.error(data.msg)
					}
				})
			})
		},
		// 接受检验
		acceptHandle(id, name) {
			this.$confirm(`确认要接受本次报验申请吗?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + "/business/testrecord/updateApplyReady",
					method: 'post',
					data: this.$http.adornData({
						testId: id
					})
				}).then(({ data }) => {
					if (data && data.resultCode === 200) {
						this.$message({
							message: '接受申请成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getDataList()
							}
						})
					} else {
						this.$message.error(data.msg)
					}
				})
			})
		},
		// 审核
		auditeHandle(id) {
			this.auditVisible = true;
			this.$nextTick(() => {
				this.$refs.audit.init(id, this.category)
			})
		},
		lookHandle(id) {
			this.lookVisible = true;
			this.$nextTick(() => {
				this.$refs.look.init(id, this.category)
			})
		},
		deleteHandle(id) {
			this.tableSelIdArray = [];
			this.tableSelIdArray.push(id);
			if (this.tableSelIdArray.length === 0) {
				this.$message.error("请选择需要删除的报验项目数据");
			} else {
				this.$confirm(`确定对选中的数据进行删除操作?`, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$http({
						url: this.$store.state.httpUrl + "/business/testrecord/delete",
						method: 'post',
						data: this.tableSelIdArray,
					}).then(({
						data
					}) => {
						if (data && data.resultCode === 200) {
							this.$message({
								message: '操作成功',
								type: 'success',
								duration: 1500,
								onClose: () => {
									this.getDataList()
								}
							})
						}
					})
				});
			}
		},
		deleteBatch() {
			this.$confirm(`确定对选中的数据进行删除操作？`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				let records = this.tableSelVals.map((item) => item.testId);
				this.$http({
					url: this.$store.state.httpUrl + "/business/testrecord/delete",
					method: 'post',
					data: records,
				}).then(({ data }) => {
					if (data && data.resultCode === 200) {
						this.$message.success('操作成功');

						// 【关键顺序】先刷新数据 → 再重置 tableKey
						this.getDataList();
						this.tableKey++;

						// 清空选中（避免残留）
						this.tableSelVals = [];
						this.disabledBatchDelete = true;
					}
				});
			});
		},
		updatePrimaryFlg(id) {
			if (!id) {
				return;
			}
			this.$http({
				url: this.$store.state.httpUrl + "/business/testrecord/updateTestRecordPrimaryFlg/" + id,
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.getDataList()
				}
			});
		},
		resetFormData() {
			// this.subjectNo = ""
			// this.major = "";
			this.conclusion = "";
			this.testDate = [];
			this.testConclusion = "";
			this.state = '';
			this.partsName = '';
			this.probContext = '';
			this.sutContent = '';
			this.closeState = '';
			this.recSortCode = ''
		},
		selGetDataList() {
			this.pageIndex = 1;
			this.getDataList();
		},
		// 每页数
		sizeChangeHandle(val) {
			this.pageSize = val;
			this.pageIndex = 1;
			this.getDataList();
		},
		// 当前页
		currentChangeHandle(val) {
			this.pageIndex = val;
			this.getDataList();
		},
		tableRowClassName({ row, rowIndex }) {
			// 关键：强制用 row.closeState 判断，不依赖任何缓存
			if (row && row.closeState === '1') {
				return 'close-row';
			}
			return '';
		},
		selectRowBackground({ row }) {
			const checkIdList = this.tableSelVals.map((item) => item.testId);
			if (checkIdList.includes(row.testId)) {
				return {
					backgroundColor: "#fae8cb",
				};
			}
		},
		getConclusionClass(conclusion) {
			const classMap = {
				0: 'conclusion-normal',
				1: 'conclusion-error',
				2: 'conclusion-danger',
				3: 'conclusion-warning'
			};
			return classMap[conclusion] || '';
		}
	}
};
</script>
<style scoped="scoped">
.selItemText {
	font-size: 14px;
	color: #1c1c1c;
	display: inline-block;
	width: 80px;
}

/* .conclusion-normal {
  color: #507ce7;
}

.conclusion-warning {
  color: #e7b243;
}

.conclusion-danger {
  color: #e70013;
} */

.noteTitle {
	font-weight: bold;
	color: #00428e;
	border-bottom: 1px solid #00428e;
	padding-bottom: 10px;
}

.noteContent {
	color: #727580;
	margin-top: 10px;
	line-height: 25px;
}

.my-pagination {
	margin-right: 20px !important;
	margin-top: -10px !important;
}

/* 表格样式补充 */
::v-deep(.el-table th.el-table__cell) {
	padding: 0 0px !important;
	/* 表头左右内边距改为2px，上下保持0 */
	height: 15px !important;
	line-height: 15px !important;
}

::v-deep(.el-table .el-table__row .el-table__cell) {
	font-size: 12px !important;
	height: auto !important;
	padding: 0 0px !important;
	/* 单元格左右内边距强制设为2px（核心修改） */
	line-height: 15px !important;
	white-space: normal !important;
	word-break: break-all !important;
}

/* 去除表格边框间距 */
::v-deep(.el-table) {
	border-collapse: collapse !important;
}

::v-deep(.el-table__header-wrapper) {
	border-bottom: 0px solid #EBEEF5 !important;
}

::v-deep(.el-table__body-wrapper) {
	border-top: none !important;
	z-index: 2
}

.sp-input /deep/ .el-textarea__inner {
	font-size: 12px;
	min-height: 30px !important;
	/* 最小高度 */
	line-height: 15px !important;
	padding: 5px 8px !important;
}

/* 使用更具体的选择器路径并添加 !important */
::v-deep .el-select-dropdown.el-popper .el-scrollbar .el-select-dropdown__list .el-select-dropdown__item {
	font-size: 12px !important;
	height: 30px !important;
	line-height: 30px !important;
	padding: 0 10px !important;
}

/* 也可以单独为hover状态设置 */
::v-deep .el-select-dropdown.el-popper .el-scrollbar .el-select-dropdown__list .el-select-dropdown__item:hover {
	font-size: 12px !important;
}

/* 确保所有下拉框都应用 */
::v-deep .el-select-dropdown {
	font-size: 12px !important;
}

/* 表格内的选择器需要更具体 */
.dataListTable .sp-input ::v-deep .el-select-dropdown__item {
	font-size: 12px !important;
}

/* 或者使用属性选择器增加特异性 */
.el-select-dropdown__item[data-v-76e66394] {
	font-size: 12px !important;
}

/* 若需要同时调整输入框内的字体 */
::v-deep .el-select .el-input__inner {
	font-size: 12px !important;
}

.sp-input /deep/ .el-select .el-input__inner {
	font-size: 12px;
}

.sp-input /deep/ .el-select-dropdown__item {
	font-size: 12px;
}

.sp-input /deep/ .el-textarea__inner {
	font-size: 12px;
}

.selSubjectInput /deep/ .el-input__inner {
	width: 120px !important;
	height: 30px !important;
}

.selDateInput {
	width: 270px !important;
	margin-top: 5px;
	height: 30px;
}

.selSearchInput /deep/ .el-input__inner {
	width: 160px !important;
	height: 30px !important;
	font-size: 12px;
}

.selMajorInput /deep/ .el-input__inner {
	width: 110px !important;
	height: 30px !important;
}

.selDateInput /deep/ .el-range-separator {
	width: 40px !important;
	margin-top: -8px;
}

.selDateInput /deep/ .el-range__icon {
	line-height: 25px !important;
}

.selDateInput /deep/ .el-range__close-icon {
	line-height: 25px !important;
}

.selFormItem::v-deep .el-form-item__label {
	font-size: smaller;
}

.selFormItem2::v-deep .el-form-item__label {
	font-size: smaller;
	width: 80px !important;
	text-align: right;
	margin-left: -26px;
	margin-top: -1px
}

.box {
	height: 100%;
	overflow: auto;
}

.sp-input.small-select ::v-deep .el-input__inner {
	height: 30px !important;
	line-height: 30px !important;
	font-size: 12px !important;
	padding-right: 5px !important;
	width: 75px !important;
}

.sp-input.small-select ::v-deep .el-input__suffix {
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
}

.sp-input.small-select ::v-deep .el-input__icon {
	line-height: 30px !important;
	height: 30px !important;
}

.sp-input.small-date-picker ::v-deep .el-input__inner {
	height: 30px !important;
	line-height: 30px !important;
	font-size: 12px !important;
	padding: 0 10px 0 30px !important;
}

.sp-input.small-date-picker ::v-deep .el-input__prefix {
	left: 8px !important;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 100%;
}

.sp-input.small-date-picker ::v-deep .el-input__icon {
	line-height: 30px !important;
	height: 30px !important;
}

.sp-input.small-input ::v-deep .el-input__inner {
	height: 30px !important;
	line-height: 30px !important;
	font-size: 12px !important;
	min-height: 30px !important;
	margin-left: -10px;
}

::v-deep(.el-table .el-table__cell) {
	height: auto !important;
	min-height: 30px !important;
}

::v-deep(.el-table__body .el-input__inner) {
	width: 220px !important;
}

::v-deep(.el-table__row) {
	height: auto !important;
	min-height: 30px !important;
}

/* 移除所有边框，只保留底部边框 */
.sp-input.small-select ::v-deep .el-input__inner,
.sp-input.small-date-picker ::v-deep .el-input__inner,
.sp-input.small-input ::v-deep .el-input__inner,
.sp-input ::v-deep .el-textarea__inner {
	border: none !important;
	/* border-bottom: 1px solid #DCDFE6 !important; */
	border-radius: 0 !important;
	background-color: transparent !important;
	padding-left: 0 !important;
	/* padding-right: 0 !important; */
	box-shadow: none !important;
}

/* hover状态 */
.sp-input.small-select:hover ::v-deep .el-input__inner,
.sp-input.small-date-picker:hover ::v-deep .el-input__inner,
.sp-input.small-input:hover ::v-deep .el-input__inner,
.sp-input:hover ::v-deep .el-textarea__inner {
	/* border-bottom: 1px solid #409EFF !important; */
}

/* focus状态 */
/* .sp-input.small-select.is-focus ::v-deep .el-input__inner,
.sp-input.small-date-picker.is-focus ::v-deep .el-input__inner,
.sp-input.small-input.is-focus ::v-deep .el-input__inner,
.sp-input.is-focus ::v-deep .el-textarea__inner {
	border-bottom: 1px solid #409EFF !important;
} */

.sp-input.small-date-picker ::v-deep .el-input__inner {
	padding-left: 25px !important;
	/* 调整日期图标位置 */
	padding-right: 0 !important;
}

/* 调整el-date-picker前缀图标位置 */
.sp-input.small-date-picker ::v-deep .el-input__prefix {
	left: 0 !important;
	width: 20px !important;
}

/* 调整textarea底部边框 */
.sp-input ::v-deep .el-textarea__inner {
	min-height: 30px !important;
	line-height: 15px !important;
	padding: 5px 0 !important;
	resize: none !important;
	/* 禁止拖拽 */
}

/* 确保表格单元格内边距 */
::v-deep(.el-table .el-table__cell) {
	padding: 0 8px !important;
}

/* 巡检类型下拉框 - 箭头在右侧，保持与文本对齐 */
.sp-input.small-select.right-arrow ::v-deep .el-input__inner {
	padding-right: 5px !important;
	text-align: left !important;
}

/* 确保下拉箭头在右侧 */
.sp-input.small-select.right-arrow ::v-deep .el-input__suffix {
	right: 0 !important;
}

.sp-input ::v-deep .el-input__inner,
.sp-input ::v-deep .el-textarea__inner {
	font-size: 12px;
	min-height: 30px !important;
	line-height: 15px !important;
	padding: 5px 0px !important;
	/* 输入框内边距左右改为2px，匹配单元格间距 */
	margin: 0 !important;
	/* 去除输入框额外外边距 */
	width: 100% !important;
	/* 输入框宽度铺满单元格 */
	box-sizing: border-box !important;
	/* 确保内边距不超出宽度 */
}

/* 下拉选择框适配 */
.sp-input ::v-deep .el-select .el-input__inner {
	padding-left: 0px !important;
	padding-right: 0px !important;
}

/* 日期选择器适配 */
.sp-input ::v-deep .el-date-editor .el-input__inner {
	padding: 0 0px !important;
	width: 100% !important;
}

/* 下拉选项样式适配 */
::v-deep .el-select-dropdown.el-popper .el-scrollbar .el-select-dropdown__list .el-select-dropdown__item {
	font-size: 12px !important;
	height: 30px !important;
	line-height: 30px !important;
	padding: 0 0px !important;
	/* 下拉选项左右内边距2px */
}

::v-deep .el-select-dropdown.el-popper .el-scrollbar .el-select-dropdown__list .el-select-dropdown__item:hover {
	font-size: 12px !important;
}

/* 小尺寸输入框特殊适配 */
.sp-input.small-input ::v-deep .el-input__inner {
	padding: 0 0px !important;
}

.sp-input.small-date-picker ::v-deep .el-date-editor .el-input__inner {
	width: 100% !important;
	padding: 0 0px !important;
}

.sp-input.small-select ::v-deep .el-select .el-input__inner {
	width: 100% !important;
	padding: 0 0px !important;
}

/* 确保备注列内容不会溢出到操作列下方 */
.remark-content {
	display: block;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	max-width: 100%;
}

.search_label {
	width: 60px;
	font-size: 13px;
	margin-right: 20px;
	margin-left: 20px;
}

::v-deep(.el-table__fixed) {
	z-index: 2 !important;
	/* 从 3 改为 2，低于滚动条区域或持平 */
	pointer-events: none;
	/* 让固定列容器不拦截鼠标事件，但内部单元格仍需可点 */
}

/* 确保固定列的单元格边框完整 */
::v-deep(.el-table__fixed-right::before) {
	background-color: white !important;
	box-shadow: -1px 0 0 #EBEEF5 !important;
	/* 模拟边框，防止穿透 */
}

/* 确保表格横向滚动条出现时，固定列完全覆盖 */
::v-deep(.el-table__body-wrapper) {
	overflow-x: auto !important;
	/* 确保滚动条区域可交互 */
	position: relative;
	z-index: 1;
}

/* 确保固定列单元格的padding和内边距正常 */
::v-deep(.el-table__fixed .el-table__cell) {
	padding: 0 8px !important;
	box-shadow: none !important;
	pointer-events: auto;
	/* 恢复单元格的鼠标事件 */
}

/* 固定列表头也需要恢复鼠标事件 */
::v-deep(.el-table__fixed-header-wrapper) {
	pointer-events: auto;
}

/* 固定列表体也需要恢复鼠标事件 */
::v-deep(.el-table__fixed-body-wrapper) {
	pointer-events: auto;
}

/* 弹窗内容 */
.check-content {
	max-height: 560px;
	overflow-y: auto;
	padding: 4px 8px 8px 8px;
}

/* 自定义滚动条 */
.check-content::-webkit-scrollbar {
	width: 6px;
}

.check-content::-webkit-scrollbar-thumb {
	background: #dcdfe6;
	border-radius: 3px;
}

.check-content::-webkit-scrollbar-track {
	background: #f5f7fa;
	border-radius: 3px;
}

/* 项目卡片 */
.project-card {
	background: #fff;
	border-radius: 12px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
	margin-bottom: 20px;
	transition: all 0.2s ease;
	border: 1px solid #ebeef5;
}

.project-card:hover {
	box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.08);
	border-color: #e4e7ed;
}

/* 项目头部 */
.project-header {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 12px 16px;
	background: #fafbfc;
	border-radius: 12px 12px 0 0;
	border-bottom: 1px solid #ebeef5;
}

.project-badge {
	display: flex;
	align-items: center;
}

.project-no {
	font-size: 14px;
	font-weight: 600;
	color: #303133;
	letter-spacing: 0.5px;
}

.project-stats {
	font-size: 11px;
	color: #909399;
	background: #f0f2f5;
	padding: 2px 8px;
	border-radius: 20px;
}

/* 专业容器 */
.majors-container {
	padding: 12px 16px 16px 16px;
}

/* 专业区块 */
.major-block {
	margin-bottom: 16px;
}

.major-block:last-child {
	margin-bottom: 0;
}

/* 专业标题 */
.major-title {
	display: flex;
	align-items: baseline;
	gap: 6px;
	margin-bottom: 10px;
	padding-bottom: 6px;
	border-bottom: 1px solid #f0f0f0;
}

.major-name {
	font-size: 13px;
	font-weight: 500;
	color: #606266;
}

.missing-count {
	font-size: 11px;
	color: #f56c6c;
}

/* 缺失数字网格布局 - 固定宽度40px按钮，间距5px */
.missing-grid {
	display: flex;
	flex-wrap: wrap;
	gap: 5px;
	margin-left: 8px;
}

/* 固定宽度的数字按钮 - 40px宽 */
.missing-number-btn {
	width: 40px;
	height: 28px;
	padding: 0;
	border-radius: 4px;
	font-size: 12px;
	font-weight: 500;
	text-align: center;
	line-height: 28px;
	background: #f5f7fa;
	border: 1px solid #e4e7ed;
	color: #409eff;
	transition: all 0.2s ease;
	cursor: pointer;
	display: inline-block;
	box-sizing: border-box;
	font-family: 'Monaco', 'Menlo', 'Consolas', monospace;
}

/* 数字过长时文字缩小 */
.missing-number-btn {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

/* 悬浮效果 */
.missing-number-btn:hover {
	background: #409eff;
	border-color: #409eff;
	color: #fff;
	transform: translateY(-1px);
	box-shadow: 0 2px 6px rgba(64, 158, 255, 0.2);
}

/* 点击效果 */
.missing-number-btn:active {
	transform: translateY(0);
}

/* 当缺失数字较多时，使用网格布局优化显示 */
@media (min-width: 500px) {
	.missing-grid {
		display: grid;
		grid-template-columns: repeat(auto-fill, 40px);
		gap: 5px;
	}
}

/* 空状态 */
.empty-state {
	text-align: center;
	padding: 48px 20px;
	color: #909399;
}

.empty-state span {
	font-size: 14px;
}
</style>
